import ServiceCategorySelector from './ServiceCategorySelector';

export default ServiceCategorySelector;
